import apiClient from 'hub-http/clients/apiClient';
import { getFullUrl } from 'hubspot-url-utils';
import { LoadingKey } from '../../app-active-loading/LoadingKey';
import { getSentryExtra } from '../../error/getSentryExtra';
import Logger from '../../lib/Logger';
import { Data } from '../../signup-data/DATA';
import { getHublet } from '../../store/app/selectors';
import { getGoogleContactsSyncConnectionId, getPortalId } from '../../store/auth/selectors';
import { completeStepAction } from '../../store/flow/action-creators';
import { clearLoadingStatus } from '../../store/loading-status/action-creators';
import { getSignupDataValue } from '../../store/signup-data/selectors';
import { Tracker } from '../../store/tracking/action-creators';
import { Step } from '../../views/Step';
import { getGoogleContactsAppId, googleContactsSyncAlertCookie, GoogleSyncAlertValue, SignupInteractionByEndpointKey } from './acq136Constants'; // @ts-expect-error migration error import

import Cookies from 'js-cookie';
import { getHubSpotDomain } from '../../constants/apiEnvironments';
const LOG = Logger.getLogger('acq136');
export const createConnection = state => {
  const hublet = getHublet(state);
  const portalId = getPortalId(state);
  const appId = getGoogleContactsAppId();
  const accountId = getSignupDataValue(state, Data.GoogleAccountId);
  return apiClient.post(`${getFullUrl('app-api', {
    hubletOverride: hublet
  })}/sync-bridge/v3/accounts/${accountId}/connection?portalId=${portalId}&appId=${appId}`, {
    data: {
      objectTypes: {
        hubSpotObjectTypeId: '0-1',
        remote: 'contacts'
      }
    }
  });
};
export const saveConnection = state => {
  const hublet = getHublet(state);
  const portalId = getPortalId(state);
  const appId = getGoogleContactsAppId();
  const connectionId = getGoogleContactsSyncConnectionId(state);
  return apiClient.put(`${getFullUrl('app-api', {
    hubletOverride: hublet
  })}/sync-bridge/v3/connections/${connectionId}?portalId=${portalId}&appId=${appId}`, {
    data: {
      conflictResolution: 'DEFAULT_TO_HUBSPOT',
      rules: {
        direction: 'INBOUND',
        filters: {},
        updateOnlyDirection: 'NONE'
      },
      matchingFilter: {
        name: 'email_only',
        value: true
      },
      defaultValueDatasetParameters: []
    }
  });
};
export const activateSync = state => {
  const hublet = getHublet(state);
  const portalId = getPortalId(state);
  const appId = getGoogleContactsAppId();
  const connectionId = getGoogleContactsSyncConnectionId(state);
  return apiClient.post(`${getFullUrl('app-api', {
    hubletOverride: hublet
  })}/sync-bridge/v3/connections/${connectionId}/activate?portalId=${portalId}&appId=${appId}`);
};
export const setGoogleContactsSyncAlertCookieForUserGuideAlert = value => {
  const domain = `.${getHubSpotDomain()}`;
  Cookies.set(googleContactsSyncAlertCookie, value, {
    domain,
    path: '/',
    expires: 1 / 8
  });
};
export const handleGoogleContactsRequestError = endpointKey => dispatch => {
  dispatch(Tracker.signupInteraction(SignupInteractionByEndpointKey[endpointKey]));
  dispatch(completeStepAction({
    stepKey: Step.GoogleContactsSync
  }));
  dispatch(clearLoadingStatus(LoadingKey.GoogleContactsSyncLoading));
  setGoogleContactsSyncAlertCookieForUserGuideAlert(GoogleSyncAlertValue.warning);
};
export const handleLoginBeforeGoogleContactsSyncFailure = (error, dispatch) => {
  const {
    status
  } = error;
  LOG.warn(`attemptUserLogin-cookie: ${status || 'no-status'}`, {
    extra: getSentryExtra(error)
  });
  dispatch(Tracker.signupInteraction('login-before-google-data-sync-error'));
};